import { Box, Spinner, VStack } from '@chakra-ui/react';
import React from 'react';

// Loader Component
const Loader = () => {
  return (
    <VStack h={'90vh'} justifyContent={'center'}>
      <Box transform={'scale(3)'}>
        <Spinner size={'sm'} />
      </Box>
    </VStack>
  )
}

export default Loader;
